import { CreateSandboxForm } from "@/components/auth/create-sandbox";
import { useUser } from "@clerk/clerk-react";
import { Navigate, Link } from "react-router";
import { Loader2 } from "lucide-react";
import dgptLogo from "@/assets/dgptlogo.png";

export const CreateSandboxPage = () => {
  const { isSignedIn, isLoaded } = useUser();

  if (!isLoaded) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-background">
        <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
      </div>
    );
  }

  if (isSignedIn) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <div className="fixed inset-0 flex">
      {/* ─── Left Branding Panel (Desktop Only) ─── */}
      <div className="hidden lg:flex lg:w-1/2 relative overflow-hidden bg-zinc-950 text-white">
        {/* Subtle grid pattern overlay */}
        <div
          className="absolute inset-0 opacity-[0.04]"
          style={{
            backgroundImage: `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32' width='32' height='32' fill='none' stroke='rgb(255 255 255 / 0.15)'%3e%3cpath d='M0 .5H31.5V32'/%3e%3c/svg%3e")`,
          }}
        />

        {/* Gradient accent glow */}
        <div className="absolute -top-24 -left-24 w-96 h-96 bg-blue-600/20 rounded-full blur-3xl" />
        <div className="absolute bottom-0 right-0 w-80 h-80 bg-indigo-600/15 rounded-full blur-3xl" />

        {/* Content */}
        <div className="relative flex flex-col justify-between w-full p-12">
          {/* Logo */}
          <div className="flex items-center">
            <img src={dgptLogo} alt="DiligenceGPT" className="h-9 w-auto" />
          </div>

          {/* Tagline */}
          <div className="max-w-md space-y-6">
            <blockquote className="space-y-4">
              <p className="text-[2rem] leading-tight font-bold tracking-tight">
                Get started with
                <br />
                <span className="text-blue-400">DiligenceGPT.</span>
              </p>
              <p className="text-zinc-400 text-base leading-relaxed">
                Streamline your deal evaluation with AI-driven insights, automated data gathering, and comprehensive startup analysis — all in one platform.
              </p>
            </blockquote>
          </div>

          {/* Footer */}
          <div className="flex items-center gap-2 text-xs text-zinc-500">
            <span>© {new Date().getFullYear()} StartupFuel Inc.</span>
            <span>·</span>
            <span>All rights reserved</span>
          </div>
        </div>
      </div>

      {/* ─── Right Form Panel ─── */}
      <div className="w-full lg:w-1/2 overflow-y-auto bg-background px-6 py-12 lg:px-8">
        <div className="w-full max-w-[400px] mx-auto">
          {/* Mobile Logo (shows only on small screens) */}
          <div className="flex items-center justify-center mb-8 lg:hidden">
            <img src={dgptLogo} alt="DiligenceGPT" className="h-8 w-auto" />
          </div>

          <CreateSandboxForm />

          <p className="text-center text-sm text-muted-foreground mt-6">
            Already have an account?{" "}
            <Link to="/sign-in" className="font-medium text-primary hover:underline">
              Sign in
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};
